"use client";
import {NeoButton} from "@/components/forms/neo-button/neo-button";
import type {NextPage} from "next";
import {useRef, useState} from "react";
import {RoutesPlanMap} from "./routePlanMap";

export const RoutesPlan: NextPage = function () {
  const [showRoutelanMap, setShowRouteplanmap] = useState(true);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef?.current?.click();
    }
  };

  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (file) {
      //console.log("Selected file:", file.name);
    }
  };
  return showRoutelanMap ? (
    <>
      {/* <div className="flex w-full flex-col px-10 py-5">
        <div className="flex-row px-3">
          <NeoHeader message="Routes Plan"></NeoHeader>
        </div>
      </div> */}
      {/* <div className="min-h-[calc(100vh-63px)] flex-row px-10 py-5"> */}
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3">
        <div className="flex flex-col gap-2  rounded-xl border border-gray-200 p-10 shadow-md">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-800">
                Morning Route Plann
              </span>
              <span className="text-md text-gray-600">New route plan</span>
            </div>
            <div className="rounded-md bg-gray-200 p-1 px-6 text-sm text-gray-600">
              Draft
            </div>
          </div>
          <div className="rounded-xl border border-gray-200 bg-gray-200 p-6 text-center text-gray-500">
            <div className="flex cursor-pointer flex-col items-center justify-center gap-1">
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
              />
              <div className="text-3xl text-gray-400" onClick={handleFileClick}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.88914 7.2397C8.81916 7.2397 10.3837 5.67511 10.3837 3.74509C10.3837 1.81508 8.81916 0.250488 6.88914 0.250488C4.95912 0.250488 3.39453 1.81508 3.39453 3.74509C3.39453 5.67511 4.95912 7.2397 6.88914 7.2397Z"
                    fill="#FFC727"
                  />
                  <path
                    d="M13.4992 12.2641C13.212 10.9401 12.4804 9.75427 11.4259 8.90366C10.3714 8.05305 9.05757 7.58891 7.70277 7.58838H6.07521C4.72164 7.59358 3.41017 8.05944 2.35664 8.90929C1.3031 9.75913 0.570276 10.9423 0.278762 12.2641C0.239116 12.4442 0.240473 12.6309 0.282731 12.8104C0.32499 12.9899 0.40707 13.1576 0.522897 13.3011C0.636068 13.4418 0.779493 13.5553 0.942516 13.633C1.10554 13.7106 1.28397 13.7506 1.46456 13.7499C1.737 13.751 1.99876 13.644 2.19231 13.4523C2.69796 12.9359 3.30176 12.526 3.96819 12.2465C4.63462 11.967 5.35021 11.8236 6.07288 11.8247H7.70044C8.41871 11.8228 9.1302 11.9637 9.79357 12.2391C10.4569 12.5145 11.059 12.919 11.5647 13.429C11.6619 13.5296 11.7782 13.6098 11.9067 13.6649C12.0353 13.72 12.1736 13.7489 12.3134 13.7499C12.494 13.7506 12.6724 13.7106 12.8355 13.633C12.9985 13.5553 13.1419 13.4418 13.2551 13.3011C13.3709 13.1576 13.453 12.9899 13.4952 12.8104C13.5375 12.6309 13.5389 12.4442 13.4992 12.2641Z"
                    fill="#FFC727"
                  />
                </svg>
              </div>
              <div className="text-sm font-medium text-gray-600">
                No routes configured yet
              </div>
              <div className="text-xs text-gray-600">
                Start by adding routes and optimizing your plan
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between text-sm text-gray-600">
            <span>Created: Just now</span>
            <span>Ready to configure</span>
          </div>
          <NeoButton
            type="submit"
            color="primary"
            size="sm"
            className="gap-[5px] text-lg"
            // startContent={
            //   <Image
            //     className="h-5 w-5"
            //     src="/icons/filter.svg"
            //     alt="filter"
            //   />
            // }
          >
            Start Planning
          </NeoButton>
        </div>
        <div className="flex flex-col gap-2  rounded-xl border border-gray-200 p-10 shadow-md">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-800">
                Plan A Routes
              </span>
              <span className="text-md text-gray-600">Zone A</span>
            </div>
            <div className="rounded-md bg-gray-200 p-1 px-6 text-sm text-gray-600">
              <svg
                width="4"
                height="24"
                viewBox="0 0 4 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M4 24H0V0H4V24Z" stroke="#E5E7EB" />
                <g clip-path="url(#clip0_7954_8667)">
                  <path d="M4 20H0V4H4V20Z" stroke="#E5E7EB" />
                  <path
                    d="M2 15.25C1.53587 15.25 1.09075 15.4344 0.762563 15.7626C0.434374 16.0908 0.25 16.5359 0.25 17C0.25 17.4641 0.434374 17.9092 0.762563 18.2374C1.09075 18.5656 1.53587 18.75 2 18.75C2.46413 18.75 2.90925 18.5656 3.23744 18.2374C3.56563 17.9092 3.75 17.4641 3.75 17C3.75 16.5359 3.56563 16.0908 3.23744 15.7626C2.90925 15.4344 2.46413 15.25 2 15.25ZM2 10.25C1.53587 10.25 1.09075 10.4344 0.762563 10.7626C0.434374 11.0908 0.25 11.5359 0.25 12C0.25 12.4641 0.434374 12.9092 0.762563 13.2374C1.09075 13.5656 1.53587 13.75 2 13.75C2.46413 13.75 2.90925 13.5656 3.23744 13.2374C3.56563 12.9092 3.75 12.4641 3.75 12C3.75 11.5359 3.56563 11.0908 3.23744 10.7626C2.90925 10.4344 2.46413 10.25 2 10.25ZM3.75 7C3.75 6.53587 3.56563 6.09075 3.23744 5.76256C2.90925 5.43437 2.46413 5.25 2 5.25C1.53587 5.25 1.09075 5.43437 0.762563 5.76256C0.434374 6.09075 0.25 6.53587 0.25 7C0.25 7.46413 0.434374 7.90925 0.762563 8.23744C1.09075 8.56563 1.53587 8.75 2 8.75C2.46413 8.75 2.90925 8.56563 3.23744 8.23744C3.56563 7.90925 3.75 7.46413 3.75 7Z"
                    fill="#9CA3AF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7954_8667">
                    <rect
                      width="4"
                      height="16"
                      fill="white"
                      transform="translate(0 4)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div className="rounded-xl border border-gray-200  p-6 text-center text-gray-500">
            <div className="flex items-center justify-between">
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-4">
                  <svg
                    width="27"
                    height="14"
                    viewBox="0 0 27 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24.2495 0.499512H1.79709C0.804149 0.499512 0 1.30488 0 2.29782V10.4313C0 10.9461 0.416776 11.3629 0.931651 11.3629H2.9984C3.13814 10.1922 4.13475 9.28144 5.34221 9.28144C6.54968 9.28144 7.54626 10.1922 7.68603 11.3629H18.3607C18.5005 10.1922 19.4971 9.28144 20.7045 9.28144C21.912 9.28144 22.9086 10.1922 23.0484 11.3629H25.1151C25.63 11.3629 26.0468 10.9461 26.0468 10.4313V2.29782C26.0468 1.30488 25.2425 0.499512 24.2495 0.499512ZM6.92104 5.3856C6.92104 5.68715 6.6771 5.93232 6.37432 5.93232L3.01557 5.9311C2.71401 5.9311 2.46884 5.68716 2.46884 5.38437V2.79908C2.46884 2.49752 2.71278 2.25235 3.01557 2.25235H6.37432C6.67587 2.25235 6.92104 2.49629 6.92104 2.79908V5.3856ZM12.4727 5.3856C12.4727 5.68715 12.2288 5.93232 11.926 5.93232L8.56725 5.9311C8.26569 5.9311 8.02052 5.68716 8.02052 5.38437V2.79908C8.02052 2.49752 8.26446 2.25235 8.56725 2.25235H11.926C12.2276 2.25235 12.4727 2.49629 12.4727 2.79908V5.3856ZM18.0244 5.3856C18.0244 5.68715 17.7805 5.93232 17.4777 5.93232L14.1189 5.9311C13.8174 5.9311 13.5722 5.68716 13.5722 5.38437V2.79908C13.5722 2.49752 13.8161 2.25235 14.1189 2.25235H17.4777C17.7792 2.25235 18.0244 2.49629 18.0244 2.79908V5.3856ZM23.5761 5.3856C23.5761 5.68715 23.3322 5.93232 23.0294 5.93232H19.6706C19.3691 5.93232 19.1239 5.68838 19.1239 5.3856V2.8003C19.1239 2.49875 19.3678 2.25358 19.6706 2.25358H23.0294C23.3309 2.25358 23.5761 2.49752 23.5761 2.8003V5.3856Z"
                      fill="#FFC727"
                    />
                    <path
                      d="M5.34223 9.78809C4.41428 9.78809 3.64569 10.4721 3.50962 11.3621C3.49491 11.454 3.48633 11.5484 3.48633 11.644C3.48633 12.6676 4.31866 13.4999 5.34226 13.4999C6.36582 13.4999 7.19818 12.6676 7.19818 11.644C7.19818 11.5484 7.18838 11.454 7.17489 11.3621C7.0376 10.4721 6.26896 9.78809 5.34223 9.78809Z"
                      fill="#FFC727"
                    />
                    <path
                      d="M20.7036 9.78809C19.7756 9.78809 19.007 10.4721 18.8709 11.3621C18.8562 11.454 18.8477 11.5484 18.8477 11.644C18.8477 12.6676 19.68 13.4999 20.7036 13.4999C21.7272 13.4999 22.5595 12.6676 22.5595 11.644C22.5595 11.5484 22.5497 11.454 22.5362 11.3621C22.4002 10.4721 21.6315 9.78809 20.7036 9.78809Z"
                      fill="#FFC727"
                    />
                  </svg>
                  10 vehicles
                </div>
                <div className="flex items-center gap-4">
                  <svg
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_7954_8681)">
                      <g clip-path="url(#clip1_7954_8681)">
                        <path
                          d="M14.75 2.625C14.75 3.99766 13.134 6.0457 12.4367 6.86328C12.3328 6.98359 12.1797 7.03008 12.0402 7H9.5C9.01602 7 8.625 7.39102 8.625 7.875C8.625 8.35898 9.01602 8.75 9.5 8.75H12.125C13.5742 8.75 14.75 9.92578 14.75 11.375C14.75 12.8242 13.5742 14 12.125 14H4.56719C4.80508 13.7293 5.09492 13.382 5.3875 12.9938C5.55977 12.7641 5.7375 12.5125 5.90703 12.25H12.125C12.609 12.25 13 11.859 13 11.375C13 10.891 12.609 10.5 12.125 10.5H9.5C8.05078 10.5 6.875 9.32422 6.875 7.875C6.875 6.42578 8.05078 5.25 9.5 5.25H10.5883C10.0141 4.38867 9.5 3.39883 9.5 2.625C9.5 1.17578 10.6758 0 12.125 0C13.5742 0 14.75 1.17578 14.75 2.625ZM3.95195 13.3738C3.84805 13.4914 3.75508 13.5953 3.67578 13.6828L3.62656 13.7375L3.62109 13.732C3.45703 13.8578 3.22187 13.8414 3.07422 13.6828C2.38516 12.9336 0.75 11.0059 0.75 9.625C0.75 8.17578 1.92578 7 3.375 7C4.82422 7 6 8.17578 6 9.625C6 10.4453 5.42305 11.457 4.81055 12.302C4.51797 12.7039 4.21719 13.0676 3.96836 13.3547L3.95195 13.3738ZM4.25 9.625C4.25 9.39294 4.15781 9.17038 3.99372 9.00628C3.82962 8.84219 3.60706 8.75 3.375 8.75C3.14294 8.75 2.92038 8.84219 2.75628 9.00628C2.59219 9.17038 2.5 9.39294 2.5 9.625C2.5 9.85706 2.59219 10.0796 2.75628 10.2437C2.92038 10.4078 3.14294 10.5 3.375 10.5C3.60706 10.5 3.82962 10.4078 3.99372 10.2437C4.15781 10.0796 4.25 9.85706 4.25 9.625ZM12.125 3.5C12.3571 3.5 12.5796 3.40781 12.7437 3.24372C12.9078 3.07962 13 2.85706 13 2.625C13 2.39294 12.9078 2.17038 12.7437 2.00628C12.5796 1.84219 12.3571 1.75 12.125 1.75C11.8929 1.75 11.6704 1.84219 11.5063 2.00628C11.3422 2.17038 11.25 2.39294 11.25 2.625C11.25 2.85706 11.3422 3.07962 11.5063 3.24372C11.6704 3.40781 11.8929 3.5 12.125 3.5Z"
                          fill="#FFC727"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_7954_8681">
                        <rect
                          width="14"
                          height="14"
                          fill="white"
                          transform="translate(0.75)"
                        />
                      </clipPath>
                      <clipPath id="clip1_7954_8681">
                        <path d="M0.75 0H14.75V14H0.75V0Z" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  10 Routes
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2">
                  <svg
                    width="11"
                    height="14"
                    viewBox="0 0 11 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.39805 13.65C7.80078 11.8945 11 7.63984 11 5.25C11 2.35156 8.64844 0 5.75 0C2.85156 0 0.5 2.35156 0.5 5.25C0.5 7.63984 3.69922 11.8945 5.10195 13.65C5.43828 14.0684 6.06172 14.0684 6.39805 13.65ZM5.75 3.5C6.21413 3.5 6.65925 3.68437 6.98744 4.01256C7.31563 4.34075 7.5 4.78587 7.5 5.25C7.5 5.71413 7.31563 6.15925 6.98744 6.48744C6.65925 6.81563 6.21413 7 5.75 7C5.28587 7 4.84075 6.81563 4.51256 6.48744C4.18437 6.15925 4 5.71413 4 5.25C4 4.78587 4.18437 4.34075 4.51256 4.01256C4.84075 3.68437 5.28587 3.5 5.75 3.5Z"
                      fill="#FFC727"
                    />
                  </svg>
                  10 BPs
                </div>
                <div className="flex items-center gap-2">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.88914 7.2397C8.81916 7.2397 10.3837 5.67511 10.3837 3.74509C10.3837 1.81508 8.81916 0.250488 6.88914 0.250488C4.95912 0.250488 3.39453 1.81508 3.39453 3.74509C3.39453 5.67511 4.95912 7.2397 6.88914 7.2397Z"
                      fill="#FFC727"
                    />
                    <path
                      d="M13.4992 12.2641C13.212 10.9401 12.4804 9.75427 11.4259 8.90366C10.3714 8.05305 9.05757 7.58891 7.70277 7.58838H6.07521C4.72164 7.59358 3.41017 8.05944 2.35664 8.90929C1.3031 9.75913 0.570276 10.9423 0.278762 12.2641C0.239116 12.4442 0.240473 12.6309 0.282731 12.8104C0.32499 12.9899 0.40707 13.1576 0.522897 13.3011C0.636068 13.4418 0.779493 13.5553 0.942516 13.633C1.10554 13.7106 1.28397 13.7506 1.46456 13.7499C1.737 13.751 1.99876 13.644 2.19231 13.4523C2.69796 12.9359 3.30176 12.526 3.96819 12.2465C4.63462 11.967 5.35021 11.8236 6.07288 11.8247H7.70044C8.41871 11.8228 9.1302 11.9637 9.79357 12.2391C10.4569 12.5145 11.059 12.919 11.5647 13.429C11.6619 13.5296 11.7782 13.6098 11.9067 13.6649C12.0353 13.72 12.1736 13.7489 12.3134 13.7499C12.494 13.7506 12.6724 13.7106 12.8355 13.633C12.9985 13.5553 13.1419 13.4418 13.2551 13.3011C13.3709 13.1576 13.453 12.9899 13.4952 12.8104C13.5375 12.6309 13.5389 12.4442 13.4992 12.2641Z"
                      fill="#FFC727"
                    />
                  </svg>
                  110 Users
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between text-sm text-gray-600">
            <span>Created: Just now</span>
            <span>Ready to configure</span>
          </div>
          <NeoButton
            type="submit"
            color="black"
            size="sm"
            className="gap-[5px] text-lg"
            onClick={() => setShowRouteplanmap(false)}
            // startContent={
            //   <Image
            //     className="h-5 w-5"
            //     src="/icons/filter.svg"
            //     alt="filter"
            //   />
            // }
          >
            Continue
          </NeoButton>
        </div>
        <div className="flex flex-col gap-2  rounded-xl border border-gray-200 p-10 shadow-md">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-800">
                Plan A Routes
              </span>
              <span className="text-md text-gray-600">Zone A</span>
            </div>
            <div className="rounded-md bg-gray-200 p-1 px-6 text-sm text-gray-600">
              <svg
                width="4"
                height="24"
                viewBox="0 0 4 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M4 24H0V0H4V24Z" stroke="#E5E7EB" />
                <g clip-path="url(#clip0_7954_8667)">
                  <path d="M4 20H0V4H4V20Z" stroke="#E5E7EB" />
                  <path
                    d="M2 15.25C1.53587 15.25 1.09075 15.4344 0.762563 15.7626C0.434374 16.0908 0.25 16.5359 0.25 17C0.25 17.4641 0.434374 17.9092 0.762563 18.2374C1.09075 18.5656 1.53587 18.75 2 18.75C2.46413 18.75 2.90925 18.5656 3.23744 18.2374C3.56563 17.9092 3.75 17.4641 3.75 17C3.75 16.5359 3.56563 16.0908 3.23744 15.7626C2.90925 15.4344 2.46413 15.25 2 15.25ZM2 10.25C1.53587 10.25 1.09075 10.4344 0.762563 10.7626C0.434374 11.0908 0.25 11.5359 0.25 12C0.25 12.4641 0.434374 12.9092 0.762563 13.2374C1.09075 13.5656 1.53587 13.75 2 13.75C2.46413 13.75 2.90925 13.5656 3.23744 13.2374C3.56563 12.9092 3.75 12.4641 3.75 12C3.75 11.5359 3.56563 11.0908 3.23744 10.7626C2.90925 10.4344 2.46413 10.25 2 10.25ZM3.75 7C3.75 6.53587 3.56563 6.09075 3.23744 5.76256C2.90925 5.43437 2.46413 5.25 2 5.25C1.53587 5.25 1.09075 5.43437 0.762563 5.76256C0.434374 6.09075 0.25 6.53587 0.25 7C0.25 7.46413 0.434374 7.90925 0.762563 8.23744C1.09075 8.56563 1.53587 8.75 2 8.75C2.46413 8.75 2.90925 8.56563 3.23744 8.23744C3.56563 7.90925 3.75 7.46413 3.75 7Z"
                    fill="#9CA3AF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7954_8667">
                    <rect
                      width="4"
                      height="16"
                      fill="white"
                      transform="translate(0 4)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div className="rounded-xl border border-gray-200  p-6 text-center text-gray-500">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <svg
                  width="27"
                  height="14"
                  viewBox="0 0 27 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.2495 0.499512H1.79709C0.804149 0.499512 0 1.30488 0 2.29782V10.4313C0 10.9461 0.416776 11.3629 0.931651 11.3629H2.9984C3.13814 10.1922 4.13475 9.28144 5.34221 9.28144C6.54968 9.28144 7.54626 10.1922 7.68603 11.3629H18.3607C18.5005 10.1922 19.4971 9.28144 20.7045 9.28144C21.912 9.28144 22.9086 10.1922 23.0484 11.3629H25.1151C25.63 11.3629 26.0468 10.9461 26.0468 10.4313V2.29782C26.0468 1.30488 25.2425 0.499512 24.2495 0.499512ZM6.92104 5.3856C6.92104 5.68715 6.6771 5.93232 6.37432 5.93232L3.01557 5.9311C2.71401 5.9311 2.46884 5.68716 2.46884 5.38437V2.79908C2.46884 2.49752 2.71278 2.25235 3.01557 2.25235H6.37432C6.67587 2.25235 6.92104 2.49629 6.92104 2.79908V5.3856ZM12.4727 5.3856C12.4727 5.68715 12.2288 5.93232 11.926 5.93232L8.56725 5.9311C8.26569 5.9311 8.02052 5.68716 8.02052 5.38437V2.79908C8.02052 2.49752 8.26446 2.25235 8.56725 2.25235H11.926C12.2276 2.25235 12.4727 2.49629 12.4727 2.79908V5.3856ZM18.0244 5.3856C18.0244 5.68715 17.7805 5.93232 17.4777 5.93232L14.1189 5.9311C13.8174 5.9311 13.5722 5.68716 13.5722 5.38437V2.79908C13.5722 2.49752 13.8161 2.25235 14.1189 2.25235H17.4777C17.7792 2.25235 18.0244 2.49629 18.0244 2.79908V5.3856ZM23.5761 5.3856C23.5761 5.68715 23.3322 5.93232 23.0294 5.93232H19.6706C19.3691 5.93232 19.1239 5.68838 19.1239 5.3856V2.8003C19.1239 2.49875 19.3678 2.25358 19.6706 2.25358H23.0294C23.3309 2.25358 23.5761 2.49752 23.5761 2.8003V5.3856Z"
                    fill="#FFC727"
                  />
                  <path
                    d="M5.34223 9.78809C4.41428 9.78809 3.64569 10.4721 3.50962 11.3621C3.49491 11.454 3.48633 11.5484 3.48633 11.644C3.48633 12.6676 4.31866 13.4999 5.34226 13.4999C6.36582 13.4999 7.19818 12.6676 7.19818 11.644C7.19818 11.5484 7.18838 11.454 7.17489 11.3621C7.0376 10.4721 6.26896 9.78809 5.34223 9.78809Z"
                    fill="#FFC727"
                  />
                  <path
                    d="M20.7036 9.78809C19.7756 9.78809 19.007 10.4721 18.8709 11.3621C18.8562 11.454 18.8477 11.5484 18.8477 11.644C18.8477 12.6676 19.68 13.4999 20.7036 13.4999C21.7272 13.4999 22.5595 12.6676 22.5595 11.644C22.5595 11.5484 22.5497 11.454 22.5362 11.3621C22.4002 10.4721 21.6315 9.78809 20.7036 9.78809Z"
                    fill="#FFC727"
                  />
                </svg>
                10 vehicles
              </div>
              <div className="flex items-center gap-4">
                <svg
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7954_8681)">
                    <g clip-path="url(#clip1_7954_8681)">
                      <path
                        d="M14.75 2.625C14.75 3.99766 13.134 6.0457 12.4367 6.86328C12.3328 6.98359 12.1797 7.03008 12.0402 7H9.5C9.01602 7 8.625 7.39102 8.625 7.875C8.625 8.35898 9.01602 8.75 9.5 8.75H12.125C13.5742 8.75 14.75 9.92578 14.75 11.375C14.75 12.8242 13.5742 14 12.125 14H4.56719C4.80508 13.7293 5.09492 13.382 5.3875 12.9938C5.55977 12.7641 5.7375 12.5125 5.90703 12.25H12.125C12.609 12.25 13 11.859 13 11.375C13 10.891 12.609 10.5 12.125 10.5H9.5C8.05078 10.5 6.875 9.32422 6.875 7.875C6.875 6.42578 8.05078 5.25 9.5 5.25H10.5883C10.0141 4.38867 9.5 3.39883 9.5 2.625C9.5 1.17578 10.6758 0 12.125 0C13.5742 0 14.75 1.17578 14.75 2.625ZM3.95195 13.3738C3.84805 13.4914 3.75508 13.5953 3.67578 13.6828L3.62656 13.7375L3.62109 13.732C3.45703 13.8578 3.22187 13.8414 3.07422 13.6828C2.38516 12.9336 0.75 11.0059 0.75 9.625C0.75 8.17578 1.92578 7 3.375 7C4.82422 7 6 8.17578 6 9.625C6 10.4453 5.42305 11.457 4.81055 12.302C4.51797 12.7039 4.21719 13.0676 3.96836 13.3547L3.95195 13.3738ZM4.25 9.625C4.25 9.39294 4.15781 9.17038 3.99372 9.00628C3.82962 8.84219 3.60706 8.75 3.375 8.75C3.14294 8.75 2.92038 8.84219 2.75628 9.00628C2.59219 9.17038 2.5 9.39294 2.5 9.625C2.5 9.85706 2.59219 10.0796 2.75628 10.2437C2.92038 10.4078 3.14294 10.5 3.375 10.5C3.60706 10.5 3.82962 10.4078 3.99372 10.2437C4.15781 10.0796 4.25 9.85706 4.25 9.625ZM12.125 3.5C12.3571 3.5 12.5796 3.40781 12.7437 3.24372C12.9078 3.07962 13 2.85706 13 2.625C13 2.39294 12.9078 2.17038 12.7437 2.00628C12.5796 1.84219 12.3571 1.75 12.125 1.75C11.8929 1.75 11.6704 1.84219 11.5063 2.00628C11.3422 2.17038 11.25 2.39294 11.25 2.625C11.25 2.85706 11.3422 3.07962 11.5063 3.24372C11.6704 3.40781 11.8929 3.5 12.125 3.5Z"
                        fill="#FFC727"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_7954_8681">
                      <rect
                        width="14"
                        height="14"
                        fill="white"
                        transform="translate(0.75)"
                      />
                    </clipPath>
                    <clipPath id="clip1_7954_8681">
                      <path d="M0.75 0H14.75V14H0.75V0Z" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                10 Routes
              </div>
              <div className="flex items-center gap-2">
                <svg
                  width="11"
                  height="14"
                  viewBox="0 0 11 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.39805 13.65C7.80078 11.8945 11 7.63984 11 5.25C11 2.35156 8.64844 0 5.75 0C2.85156 0 0.5 2.35156 0.5 5.25C0.5 7.63984 3.69922 11.8945 5.10195 13.65C5.43828 14.0684 6.06172 14.0684 6.39805 13.65ZM5.75 3.5C6.21413 3.5 6.65925 3.68437 6.98744 4.01256C7.31563 4.34075 7.5 4.78587 7.5 5.25C7.5 5.71413 7.31563 6.15925 6.98744 6.48744C6.65925 6.81563 6.21413 7 5.75 7C5.28587 7 4.84075 6.81563 4.51256 6.48744C4.18437 6.15925 4 5.71413 4 5.25C4 4.78587 4.18437 4.34075 4.51256 4.01256C4.84075 3.68437 5.28587 3.5 5.75 3.5Z"
                    fill="#FFC727"
                  />
                </svg>
                10 BPs
              </div>
              <div className="flex items-center gap-2">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.88914 7.2397C8.81916 7.2397 10.3837 5.67511 10.3837 3.74509C10.3837 1.81508 8.81916 0.250488 6.88914 0.250488C4.95912 0.250488 3.39453 1.81508 3.39453 3.74509C3.39453 5.67511 4.95912 7.2397 6.88914 7.2397Z"
                    fill="#FFC727"
                  />
                  <path
                    d="M13.4992 12.2641C13.212 10.9401 12.4804 9.75427 11.4259 8.90366C10.3714 8.05305 9.05757 7.58891 7.70277 7.58838H6.07521C4.72164 7.59358 3.41017 8.05944 2.35664 8.90929C1.3031 9.75913 0.570276 10.9423 0.278762 12.2641C0.239116 12.4442 0.240473 12.6309 0.282731 12.8104C0.32499 12.9899 0.40707 13.1576 0.522897 13.3011C0.636068 13.4418 0.779493 13.5553 0.942516 13.633C1.10554 13.7106 1.28397 13.7506 1.46456 13.7499C1.737 13.751 1.99876 13.644 2.19231 13.4523C2.69796 12.9359 3.30176 12.526 3.96819 12.2465C4.63462 11.967 5.35021 11.8236 6.07288 11.8247H7.70044C8.41871 11.8228 9.1302 11.9637 9.79357 12.2391C10.4569 12.5145 11.059 12.919 11.5647 13.429C11.6619 13.5296 11.7782 13.6098 11.9067 13.6649C12.0353 13.72 12.1736 13.7489 12.3134 13.7499C12.494 13.7506 12.6724 13.7106 12.8355 13.633C12.9985 13.5553 13.1419 13.4418 13.2551 13.3011C13.3709 13.1576 13.453 12.9899 13.4952 12.8104C13.5375 12.6309 13.5389 12.4442 13.4992 12.2641Z"
                    fill="#FFC727"
                  />
                </svg>
                110 Users
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between text-sm text-gray-600">
            <span>Created: Just now</span>
            <span>Ready to configure</span>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  ) : (
    <RoutesPlanMap />
  );
};
